"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@remirror/react");
const clsx_1 = __importDefault(require("clsx"));
const EditorToolbar_1 = require("../EditorToolbar");
const EditorContext_1 = require("./EditorContext");
const Extensions_1 = require("../Extensions/Extensions");
const hooks_1 = require("../hooks");
const extension_react_tables_1 = require("@remirror/extension-react-tables");
const EditorInput_1 = require("../ui/EditorInput/EditorInput");
const Editor = ({ attributes, border = true, children, className, containers, content, editable = true, enableDecorations = true, enableTableTool = false, isFocused: isInitiallyFocused = false, label = 'Text editor', onChange, }) => {
    const isEmpty = containers?.toolbar && containers.input && !children;
    const { manager, state, setState } = (0, react_2.useRemirror)({
        extensions: (0, Extensions_1.createExtensions)((0, react_1.useContext)(EditorContext_1.EditorContext), enableDecorations),
        content,
        selection: 'start',
        stringHandler: 'html',
    });
    const handleChange = (parameter) => {
        setState(parameter.state);
        onChange?.(parameter);
    };
    const wrapperRef = (0, react_1.useRef)(null);
    const { isFocused, handleFocus, handleBlur } = (0, hooks_1.useFocus)(isInitiallyFocused, (0, react_1.useCallback)((element) => {
        return Boolean(wrapperRef.current?.contains(element) ||
            containers?.input?.contains(element) ||
            containers?.toolbar?.contains(element));
    }, [containers?.input, containers?.toolbar]));
    // On initial load, check if we need to focus the actual text content
    (0, react_1.useEffect)(() => {
        if (isInitiallyFocused) {
            manager.view.dom.focus();
        }
        // TODO: May want to come back to this and see if there's a better solution
        // We have to add a type button attribute to the delete buttons so they don't cause a submit by accident.
        const tableDeleteButtons = document.querySelectorAll('.remirror-table-delete-inner-button');
        tableDeleteButtons.forEach((button) => {
            button.setAttribute('type', 'button');
        });
    }, []);
    return (react_1.default.createElement("div", { ref: wrapperRef, onBlurCapture: handleBlur, onFocusCapture: handleFocus, className: (0, clsx_1.default)('squiz-fte-scope', 'squiz-fte-scope__editor', !editable && 'squiz-fte-scope__editor--is-disabled', border && 'squiz-fte-scope__editor--bordered', isEmpty && 'squiz-fte-scope__editor--empty', className) },
        react_1.default.createElement(react_2.Remirror, { manager: manager, initialContent: state, editable: editable, onChange: handleChange, placeholder: "Write something", label: label, attributes: attributes },
            editable && (react_1.default.createElement(EditorToolbar_1.Toolbar, { isVisible: isFocused, enableTableTool: enableTableTool, container: containers?.toolbar })),
            children && react_1.default.createElement("div", { className: "squiz-fte-scope__editor__children" }, children),
            react_1.default.createElement(EditorInput_1.EditorInput, { container: containers?.input }),
            enableTableTool && react_1.default.createElement(extension_react_tables_1.TableComponents, { enableTableCellMenu: false }),
            editable && isFocused && react_1.default.createElement(EditorToolbar_1.FloatingToolbar, null))));
};
exports.default = Editor;
